import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMailIconSecondary from './svgs/MailIconSecondary.js';
import SvgMailIcon from './svgs/MailIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var mailIcon = (props => useIcon(SvgMailIcon, SvgMailIconSecondary, props));

export { mailIcon as default };
